(ns rothko.theme.manatee.form.input
  (:refer-clojure :exclude [rem + - * /])
  (:require [garden.units :refer [px rem]]
            [garden.arithmetic :refer [+ - * /]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def border-width (rem 0.2))
(def min-height (rem 4)) ;; TODO this is still set in rothko.form.styles
(def total-height
  (+ (* 2 border-width)
     min-height))

(def input
  {:select
   {:border-width border-width
    :border-color (:blue-light colours)}

   :primary
   {:border-width border-width
    :border-color (:blue-light colours)}

   :error
   {:border-color :red}})
